
import { Account } from "model";
import React from 'react';
import { useDrag, useDrop } from "react-dnd";
import { SVGAsset } from "res";

/**
 * @function AccountTileView
 * @return {React.Component}
 * @exported true
 * @description The component that shows the account tile
 */

export default function AccountTileView(props) {
    const account = props.account ?? Account.firstInstanceOf();
    const ref = React.useRef(null);

    // React-dnd documentation: https://react-dnd.github.io/react-dnd/docs/overview
    // Immutability-helper documentation: https://www.npmjs.com/package/immutability-helper

    // useDrop is the hook that sets a component as a droppable location
    const [{ handlerId }, drop] = useDrop({
        accept: "card",
        collect: monitor => ({ handlerId: monitor.getHandlerId() }),
        hover: (item, monitor) => {
            if (!ref.current) { return; }

            const dragIndex = item.index;
            const hoverIndex = props.index;

            if (dragIndex === hoverIndex) { return; }

            const hoverBoundingReact = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingReact.bottom - hoverBoundingReact.top) / 4;

            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingReact.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) { return; }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) { return; }

            props.onMoveItem(dragIndex, hoverIndex);
            item.index = hoverIndex;
        }
    });

    // useDrag hook sets the component as a draggable item
    const [{ isDragging }, drag, preview] = useDrag({
        type: "card",
        item: () => ({ id: props.id, index: props.index }),
        collect: monitor => ({ isDragging: monitor.isDragging() })
    });
    const opacity = isDragging ? 0 : 1;

    preview(drop(ref));

    return (
        <div className="account-tile-view flex-container flex-horizontal align-center" ref={ref} style={{ opacity }} data-handler-id={handlerId}>
            <span ref={drag}>
                <SVGAsset id="DragDropIcon" className="drag-drop-icon set-width inline-text-icon left-icon clickable" />
            </span>
            <p className="flex-width"><span className="account-nickname">{account.nickname}</span> - <span>{account.number}</span></p>
        </div>
    );
}

